import React, { useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { setIsAnswered, setIsCorrectAnswer, setSelectedOption, topicTestsConst } from 'modules/mavzuli-test';

import { Visible } from 'components';

import { Actions } from '../actions';

import { OptionItem } from './option-item';
import { XpResult } from './xp-result';

export const Options = () => {
  const t = useTranslations();
  const { query } = useRouter();
  const dispatch = useAppDispatch();
  const isAnswered = useAppSelector(({ topicTest }) => topicTest.isAnswered);
  const banner = topicTestsConst?.subjectBannerMap[query?.subject as string];
  const isCorrectAnswer = useAppSelector(({ topicTest }) => topicTest.isCorrectAnswer);
  const questions = useAppSelector(({ topicTest }) => topicTest.test?.test[0]?.questions);
  const currentQuestionIndex = useAppSelector(({ topicTest }) => topicTest.currentQuestionIndex);

  const question = questions?.[currentQuestionIndex as number];

  const options = useMemo(
    () => [
      { label: t('A_variant'), name: question?.var_a_name, id: question?.var_a_id, image: question?.var_a_image },
      { label: t('B_variant'), name: question?.var_b_name, id: question?.var_b_id, image: question?.var_b_image },
      { label: t('C_variant'), name: question?.var_c_name, id: question?.var_c_id, image: question?.var_c_image },
      { label: t('D_variant'), name: question?.var_d_name, id: question?.var_d_id, image: question?.var_d_image }
    ],
    [question, t]
  );

  const handleOptionSelect = (optionId: number) => () => {
    if (!isAnswered) {
      dispatch(setSelectedOption(optionId));
    }
  };

  useEffect(() => {
    // oldin javob variantini tanlab qoygan bo'lsa
    if (question?.checked) {
      dispatch(setIsAnswered(true));
      dispatch(setSelectedOption(question?.id));
      dispatch(
        setIsCorrectAnswer(question?.checked ? question[`var_${question?.checked}_id`] === question?.is_true : false)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question]);

  return (
    <div
      className={classNames('shadow-xs rounded-xl bg-white px-4 py-3 md:mb-4', {
        'mb-22': !banner
      })}
    >
      <div className="flex flex-col gap-3">
        {options.map(option => (
          <OptionItem
            key={option.id}
            id={option.id}
            label={option.label}
            name={option.name}
            image={option.image}
            onSelect={handleOptionSelect(option.id as number)}
          />
        ))}
      </div>
      <div className="rounded-t-4xl fixed bottom-0 left-0 right-0 z-10 mt-5 flex h-24 w-full items-center justify-between bg-white px-4 max-lg:flex-col max-lg:justify-end max-lg:gap-2 max-lg:bg-transparent max-lg:px-0 max-md:shadow md:static md:h-full md:rounded-none md:bg-transparent md:p-0">
        <Visible if={isAnswered}>
          <XpResult isCorrect={isCorrectAnswer} xp={questions?.[currentQuestionIndex]?.themed_ball || 0} />
        </Visible>
        <Actions />
      </div>
    </div>
  );
};
